import React from 'react'

const React_Coding_Practice_39 = () => {
  return (
    <div>
      <h1>Coding Pratice 39</h1>
    </div>
  )
}

export default React_Coding_Practice_39
